import React from "react";
import "./Header.css";

export default function Cloneheader() {
  return (
    <section className="hero-web3">
      <div className="container">
        <header className="hero-header">
          <div className="hero-logo">
            <a href="/" className="vt-navbar__logo">
              <img
                className="hero-logo-img"
                src="/logo.webp"
                alt="ruttienthetindung"
                width="80"
                height="80"
              />
            </a>
          </div>
        </header>

        <div className="hero-content">
          <div className="hero-left">
            <h1>
              <span className="hero-script">Tuần Lễ Vàng </span>
              <br />
              <br />
              Ưu đãi giảm phí cực sâu khi rút thẻ
              <br />
            </h1>

            <p>
              Chỉ từ 1% số lượng có hạn. Nhanh chóng, an toàn, bảo mật. Uy tín
              nên khách cũ quay lại liên tục.
            </p>

            <div className="mt-5">
              <h3
                style={{
                  marginTop: "1rem",
                  fontWeight: "bold",
                  color: "#ffff",
                  textAlign: "center",
                }}
                className="hero-sec-title5"
              >
                Liên hệ ngay.
              </h3>

              <div className="hero-cta-group">
                <a
                  href="tel:0763823860"
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                      event: "click_call",
                    });
                  }}
                  className="btn-purple1 mt-3 fw-bold"
                >
                  0763 823 860
                  <span className="btn-purple-icon">📞</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
